export default __webpack_public_path__ + "static/media/trash 1.669bb887.svg";